import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { FaArrowLeft, FaInfoCircle, FaPlus, FaTrash, FaUpload, FaFileAlt, FaTimes, FaExclamationTriangle, FaCheck } from 'react-icons/fa';
import axios from 'axios';
import { toast } from 'react-toastify';
import ErpTemplate from '../../components/ErpTemplate';
import api from '../../services/api';
import InputMask from 'react-input-mask';
import '../../css/financeiro-parcela-pagar.css';
import { FinField, FinInput, FinTextarea } from '../../components/FinField';

export default function ResumoBook({ match }) {
    const eventoId = match.params.id;
    const token = localStorage.getItem('token');
    const NOVO_CONTATO_VALUE = '__novo__';
    const apiBaseUrl = process.env.REACT_APP_API_URL;
    const MAX_IMAGE_WIDTH = 1920;
    const MAX_IMAGE_HEIGHT = 1080;
    const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

    const gerarIdUnico = useCallback(() => `${Date.now()}-${Math.random().toString(16).slice(2)}`, []);

    const criarAgendaItem = useCallback(() => ({
        id: gerarIdUnico(),
        dataInicio: '',
        dataFim: '',
        titulo: '',
        descricao: ''
    }), [gerarIdUnico]);

    const criarAbItem = useCallback(() => ({
        id: gerarIdUnico(),
        data: '',
        titulo: '',
        descricoes: ['']
    }), [gerarIdUnico]);

    const criarContatoItem = useCallback(() => ({
        id: gerarIdUnico(),
        origem: 'novo',
        responsavelId: '',
        nome: '',
        email: '',
        telefone: '',
        agenda_id: null
    }), [gerarIdUnico]);

    const criarTelefoneItem = useCallback(() => ({
        id: gerarIdUnico(),
        origem: 'novo',
        responsavelId: '',
        nome: '',
        email: '',
        telefone: '',
        agenda_id: null
    }), [gerarIdUnico]);
    const [dados, setDados] = useState(null);
    const [loading, setLoading] = useState(true);
    const [erro, setErro] = useState(null);
    const [tabKey, setTabKey] = useState('dados-evento');
    const [bookDados, setBookDados] = useState({
        clienteNome: '',
        eventoNome: '',
        endereco: '',
        empresaContratante: 'ACCESS-MKT',
        responsavelNome: '',
        responsavelTelefone: '',
        responsavelEmail: ''
    });
    const [bookInicializado, setBookInicializado] = useState(false);
    const [emailErro, setEmailErro] = useState('');
    const [agendaBlocos, setAgendaBlocos] = useState([criarAgendaItem()]);
    const [agendaInicializada, setAgendaInicializada] = useState(false);
    const [contatos, setContatos] = useState([criarContatoItem()]);
    const [contatosInicializados, setContatosInicializados] = useState(false);
    const [telefones, setTelefones] = useState([criarTelefoneItem()]);
    const [telefonesInicializados, setTelefonesInicializados] = useState(false);
    const [abBlocos, setAbBlocos] = useState([criarAbItem()]);
    const [abInicializado, setAbInicializado] = useState(false);
    const [rlHcpLinhas, setRlHcpLinhas] = useState([]);
    const [rlHcpInicializado, setRlHcpInicializado] = useState(false);
    const [rlHcpImportState, setRlHcpImportState] = useState({ loading: false, erro: '' });
    const [rlHcpUploadProgresso, setRlHcpUploadProgresso] = useState({ ativo: false, nome: '', percent: 0 });
    const [rlHcpDragAtivo, setRlHcpDragAtivo] = useState(false);
    const [rlHcpFiltroTexto, setRlHcpFiltroTexto] = useState('');
    const [bookPersistido, setBookPersistido] = useState(null);
    const [inscricoesState, setInscricoesState] = useState({
        lista: [],
        loading: false,
        erro: ''
    });
    const [inscricoesFiltroTexto, setInscricoesFiltroTexto] = useState('');
    const [inscricaoExpositorState, setInscricaoExpositorState] = useState({
        lista: [],
        loading: false,
        erro: ''
    });
    const [inscricaoExpositorFiltroTexto, setInscricaoExpositorFiltroTexto] = useState('');
    const [fotosAbas, setFotosAbas] = useState([]);
    const [fotosAbaAtiva, setFotosAbaAtiva] = useState('');
    const [fotosNovoNome, setFotosNovoNome] = useState('');
    const [fotosUploadAbaId, setFotosUploadAbaId] = useState('');
    const [fotosDragAbaId, setFotosDragAbaId] = useState('');
    const [fotosModal, setFotosModal] = useState({ aberto: false, abaId: '', indice: 0 });
    const fotosInputRef = useRef(null);
    const fotosUploadAbaIdRef = useRef('');
    const [fotosUploadProgresso, setFotosUploadProgresso] = useState({ ativo: false, abaId: '', indice: 0, total: 0, nome: '', percent: 0 });

    const rlHcpInputRef = useRef(null);

    const [salvarBookState, setSalvarBookState] = useState({ loading: false, erro: '', sucesso: '' });
    const [exportarExcelState, setExportarExcelState] = useState({ loading: false });

    const normalizarTexto = useCallback((valor) => (typeof valor === 'string' ? valor.trim() : ''), []);

    const listarResponsaveis = useCallback((valor) => {
        if (Array.isArray(valor)) {
            return valor;
        }
        return valor ? [valor] : [];
    }, []);

    const isResponsavelPrincipal = useCallback((responsavel) => {
        const marcador = responsavel?.principal ?? responsavel?.pivot?.principal;
        if (typeof marcador === 'string') {
            const flag = marcador.toLowerCase();
            return flag === 'sim' || flag === 'true' || flag === '1';
        }
        return Boolean(marcador);
    }, []);

    const extrairIdsEvento = useCallback((entrada) => {
        if (!entrada && entrada !== 0) {
            return [];
        }

        if (typeof entrada === 'string') {
            const texto = normalizarTexto(entrada);
            if (!texto) {
                return [];
            }

            if (texto.startsWith('[') && texto.endsWith(']')) {
                try {
                    const parsed = JSON.parse(texto);
                    if (Array.isArray(parsed)) {
                        return parsed.flatMap((item) => extrairIdsEvento(item));
                    }
                } catch (error) {
                    return [];
                }
                return [];
            }

            return texto.split(',').map((item) => normalizarTexto(item)).filter(Boolean);
        }

        if (typeof entrada === 'number') {
            return [normalizarTexto(String(entrada))];
        }

        if (Array.isArray(entrada)) {
            return entrada.flatMap((item) => extrairIdsEvento(item));
        }

        if (typeof entrada === 'object') {
            const possiveisChaves = ['id', 'evento', 'eventoId', 'idEvento'];
            const coletados = possiveisChaves.flatMap((chave) => extrairIdsEvento(entrada[chave]));

            if (Array.isArray(entrada.data)) {
                coletados.push(...extrairIdsEvento(entrada.data));
            }

            return coletados;
        }

        return [];
    }, [normalizarTexto]);

    const entryIsParticipant = useCallback((entrada) => {
        if (!entrada || typeof entrada !== 'object') {
            return false;
        }

        const chavesRelevantes = ['id', 'nome', 'codigo', 'evento', 'aereoidadata'];
        return chavesRelevantes.some((chave) => Object.prototype.hasOwnProperty.call(entrada, chave));
    }, []);

    const obterResponsavelPrincipal = useCallback((lista) => {
        if (!Array.isArray(lista) || lista.length === 0) {
            return null;
        }
        return lista.find(isResponsavelPrincipal) || lista[0] || null;
    }, [isResponsavelPrincipal]);

    const extrairPrimeiroNome = useCallback((nomeCompleto) => {
        const texto = normalizarTexto(nomeCompleto);
        if (!texto) {
            return '';
        }
        const [primeiro] = texto.split(/\s+/);
        return primeiro || '';
    }, [normalizarTexto]);

    const primeiroValorValido = useCallback((lista) => {
        if (!Array.isArray(lista)) {
            return '';
        }
        return lista.map(normalizarTexto).find((valor) => valor) || '';
    }, [normalizarTexto]);

    const limparNumeros = useCallback((valor) => {
        if (typeof valor !== 'string') {
            return '';
        }
        return valor.replace(/\D+/g, '');
    }, []);

    const formatarCpf = useCallback((valor) => {
        const texto = normalizarTexto(valor);
        if (!texto) {
            return '';
        }
        const numeros = limparNumeros(texto);
        if (numeros.length !== 11) {
            return texto;
        }
        return `${numeros.slice(0, 3)}.${numeros.slice(3, 6)}.${numeros.slice(6, 9)}-${numeros.slice(9)}`;
    }, [limparNumeros, normalizarTexto]);

    const formatarDataCurta = useCallback((valor) => {
        const texto = normalizarTexto(valor);
        if (!texto) {
            return '';
        }
        const [dataParte] = texto.split(' ');
        if (/^\d{4}-\d{2}-\d{2}$/.test(dataParte)) {
            const [ano, mes, dia] = dataParte.split('-');
            return `${dia}/${mes}/${ano}`;
        }
        if (/^\d{2}[/-]\d{2}[/-]\d{4}$/.test(dataParte)) {
            return dataParte.replace(/-/g, '/');
        }
        return texto;
    }, [normalizarTexto]);

    const formatarHora = useCallback((valor) => {
        const texto = normalizarTexto(valor);
        if (!texto) {
            return '';
        }
        if (/^\d{4}$/.test(texto)) {
            return `${texto.slice(0, 2)}:${texto.slice(2)}`;
        }
        if (/^\d{2}:\d{2}$/.test(texto)) {
            return texto;
        }
        return texto;
    }, [normalizarTexto]);

    const valorOuHifen = useCallback((valor) => {
        const texto = normalizarTexto(valor);
        return texto || '-';
    }, [normalizarTexto]);

    const converterParaDataIso = useCallback((valor) => {
        const texto = normalizarTexto(valor);
        if (!texto) {
            return '';
        }

        // aceita formatos ISO completos (com hora) capturando apenas a parte da data
        const isoMatch = texto.match(/^(\d{4}-\d{2}-\d{2})/);
        if (isoMatch && isoMatch[1]) {
            return isoMatch[1];
        }

        const [dataParte] = texto.split(' ');

        if (/^\d{4}-\d{2}-\d{2}$/.test(dataParte)) {
            return dataParte;
        }

        if (/^\d{2}[/-]\d{2}[/-]\d{4}$/.test(dataParte)) {
            const separador = dataParte.includes('/') ? '/' : '-';
            const [dia, mes, ano] = dataParte.split(separador);
            return `${ano}-${mes}-${dia}`;
        }

        return '';
    }, [normalizarTexto]);

    const isImageFile = useCallback((file) => Boolean(file && file.type && file.type.startsWith('image/')), []);

    const lerImagem = useCallback((file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const img = new Image();
            img.onload = () => resolve({ img, dataUrl: reader.result });
            img.onerror = (error) => reject(error);
            img.src = reader.result;
        };
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
    }), []);

    const toBlobWithQuality = useCallback((canvas, quality) => new Promise((resolve) => {
        canvas.toBlob((blob) => resolve(blob), 'image/jpeg', quality);
    }), []);

    const redimensionarImagemSeNecessario = useCallback(async (file) => {
        if (!isImageFile(file)) {
            return { arquivo: file };
        }

        if (file.size <= MAX_FILE_SIZE) {
            return { arquivo: file };
        }

        try {
            const { img } = await lerImagem(file);
            const { width, height } = img;
            const precisaReduzir = width > MAX_IMAGE_WIDTH || height > MAX_IMAGE_HEIGHT || file.size > MAX_FILE_SIZE;

            if (!precisaReduzir) {
                return { arquivo: file };
            }

            const proporcao = Math.min(MAX_IMAGE_WIDTH / width, MAX_IMAGE_HEIGHT / height, 1);
            const novaLargura = Math.floor(width * proporcao);
            const novaAltura = Math.floor(height * proporcao);

            const canvas = document.createElement('canvas');
            canvas.width = novaLargura;
            canvas.height = novaAltura;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, novaLargura, novaAltura);

            let qualidade = 0.92;
            let blob = await toBlobWithQuality(canvas, qualidade);

            while (blob && blob.size > MAX_FILE_SIZE && qualidade > 0.4) {
                qualidade -= 0.1;
                blob = await toBlobWithQuality(canvas, qualidade);
            }

            if (!blob) {
                return { erro: 'Não foi possível processar a imagem.' };
            }

            if (blob.size > MAX_FILE_SIZE) {
                return { erro: 'Imagem permanece acima de 2MB mesmo após compressão.' };
            }

            const arquivoAjustado = new File([blob], file.name, { type: 'image/jpeg' });
            return { arquivo: arquivoAjustado };
        } catch (error) {
            return { erro: 'Falha ao redimensionar a imagem.' };
        }
    }, [MAX_FILE_SIZE, isImageFile, lerImagem, toBlobWithQuality]);

    const coletarListaAgenda = useCallback((evento) => {
        if (!evento) {
            return [];
        }

        const possiveisListas = [
            evento.agendas,
            evento.agenda,
            evento.eventoagenda,
            evento.evento_agenda,
            evento.agendaEvento,
            evento.agenda_evento
        ];

        const listaEncontrada = possiveisListas.find((lista) => Array.isArray(lista) && lista.length);
        return listaEncontrada || [];
    }, []);

    const normalizarAgendaRegistro = useCallback((registro) => {
        if (!registro || typeof registro !== 'object') {
            return criarAgendaItem();
        }

        const agendaId = registro?.id ?? null;
        const dataInicio = converterParaDataIso(registro.dataInicio ?? registro.data_inicio ?? registro.data ?? '');
        let dataFim = converterParaDataIso(registro.dataFim ?? registro.data_final ?? registro.datafim ?? registro.dataFim ?? '');
        const titulo = normalizarTexto(registro.titulo || registro.topico || registro.assunto || registro.nome || '');
        const descricao = normalizarTexto(
            registro.descricao ||
            registro.topicoDescricao ||
            registro.descricao_topico ||
            registro.resumo ||
            registro.observacao ||
            registro.descricaoTopico ||
            ''
        );

        if (!dataFim && dataInicio) {
            dataFim = dataInicio;
        }

        return {
            id: gerarIdUnico(),
            agendaId,
            dataInicio,
            dataFim,
            titulo,
            descricao
        };
    }, [converterParaDataIso, criarAgendaItem, gerarIdUnico, normalizarTexto]);

    const obterTelefoneResponsavel = useCallback((responsavel, evento) => {
        if (!responsavel && !evento) {
            return '';
        }

        const candidatosResponsavel = [
            responsavel?.telefone,
            responsavel?.telefone1,
            responsavel?.telefone2,
            responsavel?.celular,
            responsavel?.telefoneContato,
            responsavel?.telefonePrincipal,
            responsavel?.contatoTelefone,
            responsavel?.pivot?.telefone,
            responsavel?.pivot?.telefone1,
            responsavel?.pivot?.telefone2,
            responsavel?.pivot?.celular
        ];

        const candidatosEvento = [
            evento?.contatoTelefone,
            evento?.contato_telefone,
            evento?.telefoneContato
        ];

        return primeiroValorValido([...candidatosResponsavel, ...candidatosEvento]);
    }, [primeiroValorValido]);

    const obterEmailResponsavel = useCallback((responsavel, evento) => {
        if (!responsavel && !evento) {
            return '';
        }

        const candidatosResponsavel = [
            responsavel?.email,
            responsavel?.emailContato,
            responsavel?.email_contato,
            responsavel?.emailPrincipal,
            responsavel?.emailsecundario,
            responsavel?.contatoEmail,
            responsavel?.contato_email,
            responsavel?.pivot?.email,
            responsavel?.pivot?.emailContato,
            responsavel?.pivot?.email_contato
        ];

        const candidatosEvento = [
            evento?.contatoEmail,
            evento?.contato_email,
            evento?.emailContato
        ];

        return primeiroValorValido([...candidatosResponsavel, ...candidatosEvento]);
    }, [primeiroValorValido]);

    const obterTelefoneParticipante = useCallback((participante) => {
        if (!participante) {
            return '';
        }

        const candidatos = [
            participante.telefone,
            participante.telefone1,
            participante.telefone2,
            participante.celular,
            participante.telefoneContato,
            participante.contatoTelefone,
            participante.telefonePrincipal
        ];

        return primeiroValorValido(candidatos);
    }, [primeiroValorValido]);

    const obterEmailParticipante = useCallback((participante) => {
        if (!participante) {
            return '';
        }

        const candidatos = [
            participante.email,
            participante.emailContato,
            participante.email_contato,
            participante.emailsecundario,
            participante.contatoEmail,
            participante.contato_email,
            participante.emailPrincipal
        ];

        return primeiroValorValido(candidatos);
    }, [primeiroValorValido]);

    const participantePertenceAoEvento = useCallback((participante, eventoId) => {
        if (!participante || !eventoId) {
            return false;
        }

        const idNormalizado = normalizarTexto(String(eventoId));
        if (!idNormalizado) {
            return false;
        }

        const candidatos = [
            participante.evento,
            participante.idEvento,
            participante.eventoId,
            participante.eventos
        ];

        return candidatos
            .flatMap((item) => extrairIdsEvento(item))
            .some((identificador) => identificador === idNormalizado);
    }, [extrairIdsEvento, normalizarTexto]);

    const montarEnderecoEvento = useCallback((evento) => {
        if (!evento) {
            return '';
        }

        const candidatosLocalObjeto = [
            evento.localEvento,
            evento.eventoLocal,
            evento.local_evento,
            evento.eventolocal,
            evento.local
        ];

        const localObjeto = candidatosLocalObjeto.find((item) => item && typeof item === 'object');

        if (localObjeto) {
            const partes = [];
            const nomeLocal = normalizarTexto(localObjeto.nome || localObjeto.titulo || localObjeto.local);
            if (nomeLocal) {
                partes.push(nomeLocal);
            }

            const logradouro = normalizarTexto(localObjeto.logradouro || localObjeto.endereco || localObjeto.rua);
            const numero = normalizarTexto(localObjeto.numero);
            const linhaEndereco = normalizarTexto([logradouro, numero].filter(Boolean).join(', '));
            if (linhaEndereco) {
                partes.push(linhaEndereco);
            }

            const complemento = normalizarTexto(localObjeto.complemento);
            if (complemento) {
                partes.push(complemento);
            }

            const bairro = normalizarTexto(localObjeto.bairro);
            if (bairro) {
                partes.push(bairro);
            }

            const municipioNome = normalizarTexto(localObjeto.municipio?.nome || localObjeto.cidade);
            const uf = normalizarTexto(localObjeto.municipio?.uf || localObjeto.uf || localObjeto.estado);
            if (municipioNome && uf) {
                partes.push(`${municipioNome}/${uf}`);
            } else if (municipioNome || uf) {
                partes.push(municipioNome || uf);
            }

            const pais = normalizarTexto(localObjeto.pais || localObjeto.nomePais);
            if (pais) {
                partes.push(pais);
            }

            if (partes.length > 0) {
                return partes.join(' - ');
            }
        }

        const localTexto = typeof evento.local === 'string' ? normalizarTexto(evento.local) : '';
        const enderecoTexto = typeof evento.endereco === 'string' ? normalizarTexto(evento.endereco) : '';
        const municipioNome = normalizarTexto(evento.municipio?.nome);
        const municipioUf = normalizarTexto(evento.municipio?.uf);
        const municipioTexto = municipioNome ? `${municipioNome}${municipioUf ? `/${municipioUf}` : ''}` : '';
        const partesBasicas = [localTexto, enderecoTexto, municipioTexto].filter(Boolean);

        if (partesBasicas.length > 0) {
            return partesBasicas.join(' - ');
        }

        return '';
    }, [normalizarTexto]);

    const buscarDados = useCallback(async () => {
        try {
            setLoading(true);
            setErro(null);
            const response = await api({
                method: 'get',
                action: '/evento/' + eventoId,
                token: token,
            });

            if (response.data && response.data.data) {
                setDados(response.data.data);
            } else {
                setErro('Não foi possível carregar os dados do evento.');
            }
        } catch (error) {
            setErro('Erro ao carregar os dados do evento.');
        } finally {
            setLoading(false);
        }
    }, [eventoId, token]);

    const buscarBookPersistido = useCallback(async () => {
        if (!token) {
            return;
        }

        try {
            const response = await axios.get(`${apiBaseUrl}/evento/${eventoId}/book`, {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });

            setBookPersistido(response?.data?.data || null);
        } catch (error) {
            setBookPersistido(null);
        }
    }, [apiBaseUrl, eventoId, token]);

    useEffect(() => {
        buscarDados();
    }, [buscarDados]);

    useEffect(() => {
        buscarBookPersistido();
    }, [buscarBookPersistido]);

    // Quando o book persistido chega (ou muda), reabilita a inicialização dos blocos dependentes
    useEffect(() => {
        setContatosInicializados(false);
        setTelefonesInicializados(false);
        setAbInicializado(false);
    }, [bookPersistido]);

    const normalizarListaParticipantes = useCallback((dadosParticipantes) => {
        if (Array.isArray(dadosParticipantes)) {
            return dadosParticipantes;
        }

        if (dadosParticipantes && typeof dadosParticipantes === 'object') {
            const aparentaSerParticipante = (
                Object.prototype.hasOwnProperty.call(dadosParticipantes, 'id') ||
                Object.prototype.hasOwnProperty.call(dadosParticipantes, 'nome') ||
                Object.prototype.hasOwnProperty.call(dadosParticipantes, 'codigo')
            );

            if (aparentaSerParticipante) {
                return [dadosParticipantes];
            }

            return Object.values(dadosParticipantes).filter((entrada) => entryIsParticipant(entrada));
        }

        return [];
    }, [entryIsParticipant]);

    const buscarInscricoes = useCallback(async () => {
        try {
            setInscricoesState((prev) => ({ ...prev, loading: true, erro: '' }));
            const response = await api({
                method: 'get',
                action: '/participante',
                token: token,
                params: {
                    evento: eventoId,
                    tipoCadastro: 'participante',
                    ultimoHistorico: true,
                    ordenarPor: 'nome',
                    ordenarOrdem: 'asc'
                }
            });

            const listaCompleta = normalizarListaParticipantes(response?.data?.data);
            const listaFiltrada = listaCompleta.filter((participante) => participantePertenceAoEvento(participante, eventoId));
            const lista = listaFiltrada.length > 0 ? listaFiltrada : listaCompleta;
            setInscricoesState({ lista, loading: false, erro: '' });
        } catch (error) {
            setInscricoesState({ lista: [], loading: false, erro: 'Erro ao carregar as inscrições de participantes.' });
        }
    }, [eventoId, normalizarListaParticipantes, participantePertenceAoEvento, token]);

    const buscarInscricaoExpositor = useCallback(async () => {
        try {
            setInscricaoExpositorState((prev) => ({ ...prev, loading: true, erro: '' }));
            const response = await api({
                method: 'get',
                action: '/participante',
                token: token,
                params: {
                    evento: eventoId,
                    tipoCadastro: 'palestrante',
                    ultimoHistorico: true,
                    ordenarPor: 'nome',
                    ordenarOrdem: 'asc'
                }
            });

            const listaCompleta = normalizarListaParticipantes(response?.data?.data);
            const listaFiltrada = listaCompleta.filter((participante) => participantePertenceAoEvento(participante, eventoId));
            const lista = listaFiltrada.length > 0 ? listaFiltrada : listaCompleta;
            setInscricaoExpositorState({ lista, loading: false, erro: '' });
        } catch (error) {
            setInscricaoExpositorState({ lista: [], loading: false, erro: 'Erro ao carregar inscrições de expositores.' });
        }
    }, [eventoId, normalizarListaParticipantes, participantePertenceAoEvento, token]);

    const mapearAbasFotos = useCallback((abasApi) => {
        const abas = Array.isArray(abasApi) ? abasApi : [];
        return abas.map((aba) => {
            const fotos = Array.isArray(aba?.fotos) ? aba.fotos : [];
            const itens = fotos.map((foto) => {
                const arquivoId = foto?.arquivo_id || foto?.arquivo?.id;
                const linkDireto = foto?.arquivo?.link || foto?.arquivo?.caminhoCompleto;
                return {
                    id: foto?.id,
                    nome: foto?.arquivo?.nome || foto?.arquivo?.nome_original || foto?.arquivo?.nomeOriginal || `foto-${foto?.id}`,
                    url: linkDireto || (arquivoId ? `${apiBaseUrl}/arquivo/download/${arquivoId}?inline=1` : ''),
                };
            });

            return {
                id: aba?.id,
                nome: aba?.nome,
                itens,
            };
        });
    }, [apiBaseUrl]);

    const carregarAbasFotos = useCallback(async () => {
        try {
            const response = await axios.get(`${apiBaseUrl}/evento/${eventoId}/book/foto-abas`, {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });

            const abas = mapearAbasFotos(response?.data?.data);
            setFotosAbas(abas);

            setFotosAbaAtiva((prev) => {
                if (prev && abas.some((item) => item.id === prev)) {
                    return prev;
                }
                return abas[0]?.id || '';
            });
        } catch (error) {
            // Não bloqueia a tela inteira se falhar
            setFotosAbas([]);
        }
    }, [apiBaseUrl, eventoId, mapearAbasFotos, token]);

    const criarAbaFotos = useCallback(async () => {
        const nome = normalizarTexto(fotosNovoNome);
        if (!nome) {
            toast.error('Informe um nome para a aba de fotos.');
            return;
        }

        try {
            const response = await axios.post(
                `${apiBaseUrl}/evento/${eventoId}/book/foto-abas`,
                { nome },
                {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            const abaCriada = response?.data?.data;
            if (!abaCriada?.id) {
                throw new Error('Resposta inválida ao criar aba');
            }

            setFotosAbas((prev) => {
                const existente = Array.isArray(prev) ? prev : [];
                if (existente.some((item) => item.id === abaCriada.id)) {
                    return existente;
                }
                return [...existente, { id: abaCriada.id, nome: abaCriada.nome, itens: [] }];
            });
            setFotosAbaAtiva(abaCriada.id);
            setFotosNovoNome('');
        } catch (error) {
            toast.error('Erro ao criar aba de fotos.');
        }
    }, [apiBaseUrl, eventoId, fotosNovoNome, normalizarTexto, token]);

    const adicionarFotosNaAba = useCallback(async (abaId, arquivosInput) => {
        const arquivos = Array.from(arquivosInput || []);
        if (!abaId) {
            toast.error('Crie uma aba de fotos primeiro.');
            return;
        }

        if (!arquivos.length) {
            return;
        }

        setFotosUploadProgresso({ ativo: true, abaId, indice: 0, total: arquivos.length, nome: '', percent: 0 });

        const novos = [];
        for (let index = 0; index < arquivos.length; index += 1) {
            const arquivo = arquivos[index];
            if (!isImageFile(arquivo)) {
                toast.error('Envie apenas imagens.');
                continue;
            }

            const ajustado = await redimensionarImagemSeNecessario(arquivo);
            if (ajustado.erro) {
                toast.error(ajustado.erro);
                continue;
            }

            const arquivoFinal = ajustado.arquivo;

            try {
                setFotosUploadProgresso((prev) => ({
                    ...prev,
                    ativo: true,
                    abaId,
                    indice: index + 1,
                    total: arquivos.length,
                    nome: arquivoFinal.name,
                    percent: 0,
                }));

                const formData = new FormData();
                formData.append('file', arquivoFinal, arquivoFinal.name);

                const response = await axios.post(
                    `${apiBaseUrl}/evento/${eventoId}/book/foto-abas/${abaId}/fotos`,
                    formData,
                    {
                        headers: {
                            Accept: 'application/json',
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data'
                        },
                        onUploadProgress: (progressEvent) => {
                            const total = progressEvent?.total || 0;
                            const loaded = progressEvent?.loaded || 0;
                            const percent = total > 0 ? Math.round((loaded * 100) / total) : 0;
                            setFotosUploadProgresso((prev) => ({
                                ...prev,
                                ativo: true,
                                abaId,
                                indice: index + 1,
                                total: arquivos.length,
                                nome: arquivoFinal.name,
                                percent,
                            }));
                        },
                    }
                );

                const fotoCriada = response?.data?.data;
                const arquivoId = fotoCriada?.arquivo_id || fotoCriada?.arquivo?.id;

                if (!fotoCriada?.id || !arquivoId) {
                    throw new Error('Resposta inválida ao subir foto');
                }

                const linkDireto = fotoCriada?.arquivo?.link || fotoCriada?.arquivo?.caminhoCompleto;
                novos.push({
                    id: fotoCriada.id,
                    nome: fotoCriada?.arquivo?.nome || fotoCriada?.arquivo?.nome_original || fotoCriada?.arquivo?.nomeOriginal || arquivoFinal.name,
                    url: linkDireto || `${apiBaseUrl}/arquivo/download/${arquivoId}?inline=1`
                });
            } catch (error) {
                toast.error('Erro ao enviar imagem.');
            }
        }

        setFotosUploadProgresso((prev) => {
            if (prev?.abaId !== abaId) {
                return { ativo: false, abaId: '', indice: 0, total: 0, nome: '', percent: 0 };
            }
            return { ...prev, ativo: false, percent: 100 };
        });

        if (!novos.length) {
            return;
        }

        setFotosAbas((prev) => prev.map((aba) => {
            if (aba.id !== abaId) {
                return aba;
            }
            const itens = Array.isArray(aba.itens) ? aba.itens : [];
            return { ...aba, itens: [...itens, ...novos] };
        }));
    }, [apiBaseUrl, eventoId, isImageFile, redimensionarImagemSeNecessario, token]);

    const abrirSeletorFotos = useCallback((abaId) => {
        fotosUploadAbaIdRef.current = abaId;
        setFotosUploadAbaId(abaId);
        fotosInputRef.current?.click();
    }, []);

    const onFotosInputChange = useCallback(async (event) => {
        const arquivos = Array.from(event.target.files || []);
        event.target.value = '';

        const abaId = fotosUploadAbaIdRef.current || fotosUploadAbaId || fotosAbaAtiva;
        fotosUploadAbaIdRef.current = '';

        try {
            await adicionarFotosNaAba(abaId, arquivos);
        } catch (error) {
            toast.error('Erro ao processar o upload.');
        }
    }, [adicionarFotosNaAba, fotosAbaAtiva, fotosUploadAbaId]);

    const removerFotoDaAba = useCallback(async (abaId, fotoId) => {
        if (!abaId || !fotoId) {
            return;
        }

        try {
            await axios.delete(`${apiBaseUrl}/evento/${eventoId}/book/foto-abas/${abaId}/fotos/${fotoId}`, {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });

            setFotosAbas((prev) => prev.map((aba) => {
                if (aba.id !== abaId) {
                    return aba;
                }
                const itens = Array.isArray(aba.itens) ? aba.itens : [];
                return { ...aba, itens: itens.filter((item) => item.id !== fotoId) };
            }));
        } catch (error) {
            toast.error('Erro ao remover imagem.');
        }
    }, [apiBaseUrl, eventoId, token]);

    const removerAbaFotos = useCallback(async (abaId) => {
        if (!abaId) {
            return;
        }

        const confirmar = window.confirm('Remover esta aba e todas as fotos associadas?');
        if (!confirmar) {
            return;
        }

        try {
            await axios.delete(`${apiBaseUrl}/evento/${eventoId}/book/foto-abas/${abaId}`, {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });

            setFotosAbas((prev) => {
                const atualizado = prev.filter((aba) => aba.id !== abaId);
                if (atualizado.length === 0) {
                    setFotosAbaAtiva('');
                } else if (abaId === fotosAbaAtiva) {
                    setFotosAbaAtiva(atualizado[0].id);
                }
                return atualizado;
            });

            if (fotosUploadProgresso?.abaId === abaId) {
                setFotosUploadProgresso({ ativo: false, abaId: '', indice: 0, total: 0, nome: '', percent: 0 });
            }

            if (fotosModal.aberto && fotosModal.abaId === abaId) {
                setFotosModal({ aberto: false, abaId: '', indice: 0 });
            }

            toast.success('Aba removida com sucesso.');
        } catch (error) {
            toast.error('Erro ao remover a aba.');
        }
    }, [apiBaseUrl, eventoId, fotosAbaAtiva, fotosModal, fotosUploadProgresso, token]);

    const abrirModalFotos = useCallback((abaId, indice) => {
        setFotosModal({ aberto: true, abaId, indice });
    }, []);

    const fecharModalFotos = useCallback(() => {
        setFotosModal({ aberto: false, abaId: '', indice: 0 });
    }, []);

    const navegarModalFotos = useCallback((delta) => {
        setFotosModal((prev) => {
            if (!prev.aberto || !prev.abaId) {
                return prev;
            }
            const aba = fotosAbas.find((item) => item.id === prev.abaId);
            const total = aba?.itens?.length || 0;
            if (!total) {
                return prev;
            }
            const proximo = (prev.indice + delta + total) % total;
            return { ...prev, indice: proximo };
        });
    }, [fotosAbas]);

    useEffect(() => {
        buscarInscricoes();
    }, [buscarInscricoes]);

    useEffect(() => {
        buscarInscricaoExpositor();
    }, [buscarInscricaoExpositor]);

    useEffect(() => {
        if (!token) {
            return;
        }
        carregarAbasFotos();
    }, [carregarAbasFotos, token]);

    useEffect(() => {
        if (dados && !bookInicializado) {
            const responsaveis = listarResponsaveis(dados.responsavel);
            const responsavelPrincipal = obterResponsavelPrincipal(responsaveis) || {};
            const telefoneResponsavel = obterTelefoneResponsavel(responsavelPrincipal, dados);
            const emailResponsavel = obterEmailResponsavel(responsavelPrincipal, dados);
            const enderecoEvento = montarEnderecoEvento(dados);
            const nomeResponsavelCompleto = responsavelPrincipal?.nome
                || responsavelPrincipal?.label
                || dados.contatoNome
                || dados.contato_nome
                || '';
            const nomeResponsavel = extrairPrimeiroNome(nomeResponsavelCompleto);

            setBookDados({
                clienteNome: dados.cliente?.nome || '',
                eventoNome: dados.nome || '',
                endereco: enderecoEvento,
                empresaContratante: 'ACCESS-MKT',
                responsavelNome: nomeResponsavel,
                responsavelTelefone: telefoneResponsavel,
                responsavelEmail: emailResponsavel
            });
            setEmailErro('');
            setBookInicializado(true);
        }
    }, [bookInicializado, dados, extrairPrimeiroNome, listarResponsaveis, montarEnderecoEvento, obterEmailResponsavel, obterResponsavelPrincipal, obterTelefoneResponsavel]);

    const handleCampoChange = (campo, valor) => {
        setBookDados((prev) => ({ ...prev, [campo]: valor }));
    };

    const validarEmail = (valor) => {
        if (!valor) {
            return true;
        }
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(valor);
    };

    const handleEmailChange = (valor) => {
        setBookDados((prev) => ({ ...prev, responsavelEmail: valor }));
        setEmailErro(validarEmail(valor) ? '' : 'Informe um e-mail válido.');
    };

    const salvarBook = async () => {
        try {
            setSalvarBookState({ loading: true, erro: '', sucesso: '' });

            const normalizarOrigem = (origem, fallback) => {
                if (!origem) {
                    return fallback;
                }
                const valor = String(origem).toLowerCase();
                if (valor === 'novo' || valor === 'existente') {
                    return fallback;
                }
                return origem;
            };

            const contatosDadosEvento = (contatos || []).map((item, idx) => ({
                nome: item.nome || null,
                email: item.email || null,
                telefone: item.telefone || null,
                agenda_id: item.agenda_id || item.agendaId || null,
                origem: (item.agenda_id || item.agendaId) ? 'agenda' : normalizarOrigem(item.origem, 'dados_evento'),
                principal: Boolean(item.principal),
                ordem: typeof item.ordem === 'number' ? item.ordem : idx
            }));

            const contatosTelefones = (telefones || []).map((item, idx) => ({
                nome: item.nome || null,
                email: item.email || null,
                telefone: item.telefone || null,
                agenda_id: item.agenda_id || item.agendaId || null,
                origem: (item.agenda_id || item.agendaId) ? 'agenda' : normalizarOrigem(item.origem, 'telefone'),
                principal: Boolean(item.principal),
                ordem: typeof item.ordem === 'number' ? item.ordem : idx + contatosDadosEvento.length
            }));

            const payload = {
                book: {
                    cliente_nome: bookDados.clienteNome,
                    evento_nome: bookDados.eventoNome,
                    endereco: bookDados.endereco,
                    empresa_contratante: bookDados.empresaContratante,
                    responsavel_nome: bookDados.responsavelNome,
                    responsavel_tel: bookDados.responsavelTelefone,
                    responsavel_email: bookDados.responsavelEmail
                },
                agendas: (agendaBlocos || []).map((item, idx) => ({
                    data_inicio: item.dataInicio || null,
                    data_fim: item.dataFim || null,
                    titulo: item.titulo || null,
                    descricao: item.descricao || null,
                    ordem: idx
                })),
                contatos: [...contatosDadosEvento, ...contatosTelefones],
                ab: (abBlocos || []).map((item, idx) => ({
                    data: item.data || null,
                    titulo: item.titulo || null,
                    descricoes: (Array.isArray(item.descricoes) ? item.descricoes : [])
                        .map((texto) => (typeof texto === 'string' ? texto.trim() : ''))
                        .filter(Boolean),
                    ordem: idx
                })),
                rlhcp: (rlHcpLinhas || []).map((item, idx) => ({
                    tipo_quarto: item.tipo_quarto || null,
                    nome: item.nome || null,
                    observacao: item.observacao || null,
                    check_in: item.check_in || null,
                    check_out: item.check_out || null,
                    cpf: item.cpf || null,
                    telefone: item.telefone || null,
                    nascimento: item.nascimento || null,
                    cidade: item.cidade || null,
                    estado: item.estado || null,
                    ordem: idx
                }))
            };

            await axios.post(`${apiBaseUrl}/evento/${eventoId}/book`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setSalvarBookState({ loading: false, erro: '', sucesso: 'Book salvo com sucesso.' });
            toast.success('Book salvo com sucesso.');
        } catch (error) {
            const mensagem = error?.response?.data?.message || 'Erro ao salvar o book.';
            setSalvarBookState({ loading: false, erro: mensagem, sucesso: '' });
            toast.error(mensagem);
        }
    };

    const exportarExcelBook = async () => {
        try {
            setExportarExcelState({ loading: true });

            const response = await axios.get(`${apiBaseUrl}/evento/${eventoId}/book/exportarExcel`, {
                headers: {
                    Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    Authorization: `Bearer ${token}`
                },
                responseType: 'blob'
            });

            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Book.xlsx';
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            let mensagem = 'Erro ao exportar Excel.';

            try {
                const data = error?.response?.data;
                const contentType = error?.response?.headers?.['content-type'] || '';

                // Quando responseType='blob', erros JSON vêm como Blob
                if (data instanceof Blob) {
                    const texto = await data.text();
                    if (texto) {
                        try {
                            const json = JSON.parse(texto);
                            mensagem = json?.error || json?.msg || json?.message || mensagem;
                        } catch (e) {
                            // se não for JSON, tenta mostrar o texto bruto
                            mensagem = texto;
                        }
                    }
                } else if (contentType.includes('application/json')) {
                    mensagem = data?.error || data?.msg || data?.message || mensagem;
                } else {
                    mensagem = error?.response?.data?.error || error?.response?.data?.msg || error?.message || mensagem;
                }
            } catch (e) {
                // mantém mensagem padrão
            }

            toast.error(mensagem);
        } finally {
            setExportarExcelState({ loading: false });
        }
    };

    const responsaveisEvento = useMemo(() => {
        const lista = listarResponsaveis(dados?.responsavel);
        return lista
            .map((responsavel, index) => {
                const idCandidato = responsavel?.id ?? responsavel?.value ?? responsavel?.codigo ?? responsavel?.pivot?.id;
                const idNormalizado = idCandidato !== undefined && idCandidato !== null
                    ? normalizarTexto(String(idCandidato))
                    : '';
                const nome = normalizarTexto(responsavel?.nome || responsavel?.label || '');
                const email = normalizarTexto(obterEmailResponsavel(responsavel, dados));
                const telefone = normalizarTexto(obterTelefoneResponsavel(responsavel, dados));

                return {
                    id: idNormalizado || `responsavel-${index}`,
                    nome,
                    email,
                    telefone
                };
            })
            .filter((item) => item.nome);
    }, [dados, listarResponsaveis, normalizarTexto, obterEmailResponsavel, obterTelefoneResponsavel]);

    useEffect(() => {
        const fonteAgenda = bookPersistido || dados;
        if (!fonteAgenda || agendaInicializada) {
            return;
        }

        const listaOriginal = coletarListaAgenda(fonteAgenda);
        console.log('DEBUG - Agenda original do backend:', listaOriginal);
        
        const listaAgenda = listaOriginal
            .map((registro) => {
                const normalizado = normalizarAgendaRegistro(registro);
                console.log('DEBUG - Registro normalizado:', normalizado);
                return normalizado;
            })
            .filter((item) => item.dataInicio || item.titulo || item.descricao);

        console.log('DEBUG - Lista agenda final:', listaAgenda);

        if (listaAgenda.length) {
            setAgendaBlocos(listaAgenda);
            setAgendaInicializada(true);
        } else {
            // mantém false para tentar novamente quando o bookPersistido chegar
            setAgendaBlocos([criarAgendaItem()]);
        }
    }, [agendaInicializada, bookPersistido, coletarListaAgenda, criarAgendaItem, dados, normalizarAgendaRegistro]);

    const parseDescricoes = useCallback((valor) => {
        if (Array.isArray(valor)) {
            return valor;
        }
        if (typeof valor === 'string') {
            const texto = valor.trim();
            if (!texto) {
                return [];
            }
            if (texto.startsWith('[') && texto.endsWith(']')) {
                try {
                    const parsed = JSON.parse(texto);
                    if (Array.isArray(parsed)) {
                        return parsed;
                    }
                } catch (e) {
                    return [];
                }
            }
            // fallback: separa por quebra de linha
            const linhas = texto.split(/\r\n|\n|\r/).map((linha) => linha.trim()).filter(Boolean);
            if (linhas.length) {
                return linhas;
            }
        }
        return [];
    }, []);

    useEffect(() => {
        if (abInicializado) {
            return;
        }

        const abSalvo = bookPersistido?.ab;
        if (Array.isArray(abSalvo) && abSalvo.length) {
            const lista = abSalvo
                .map((registro, index) => {
                    let descricoes = parseDescricoes(registro?.descricoes);
                    if ((!descricoes || descricoes.length === 0) && registro?.observacao) {
                        descricoes = parseDescricoes(registro.observacao);
                    }
                    return {
                        id: registro?.id ?? `ab-${index}-${gerarIdUnico()}`,
                        data: converterParaDataIso(registro?.data || ''),
                        titulo: registro?.titulo || '',
                        descricoes: descricoes.length ? descricoes : ['']
                    };
                });

            setAbBlocos(lista);
        } else {
            setAbBlocos([criarAbItem()]);
        }

        setAbInicializado(true);
    }, [abInicializado, bookPersistido, criarAbItem, gerarIdUnico, parseDescricoes]);

    const mapearRlHcpLinhas = useCallback((dadosApi) => {
        const lista = Array.isArray(dadosApi) ? dadosApi : [];
        return lista.map((registro, index) => ({
            id: registro?.id ?? `rlhcp-${index}-${gerarIdUnico()}`,
            tipo_quarto: registro?.tipo_quarto || '',
            nome: registro?.nome || '',
            observacao: registro?.observacao || '',
            check_in: registro?.check_in || '',
            check_out: registro?.check_out || '',
            cpf: registro?.cpf || '',
            telefone: registro?.telefone || '',
            nascimento: registro?.nascimento || '',
            cidade: registro?.cidade || '',
            estado: registro?.estado || ''
        }));
    }, [gerarIdUnico]);

    useEffect(() => {
        if (rlHcpInicializado) {
            return;
        }

        if (!bookPersistido) {
            return;
        }

        const salvo = bookPersistido?.rlhcp;
        if (Array.isArray(salvo) && salvo.length) {
            setRlHcpLinhas(mapearRlHcpLinhas(salvo));
        } else {
            setRlHcpLinhas([]);
        }

        setRlHcpInicializado(true);
    }, [bookPersistido, mapearRlHcpLinhas, rlHcpInicializado]);

    useEffect(() => {
        if (contatosInicializados) {
            return;
        }

        const contatosSalvos = Array.isArray(bookPersistido?.contatos)
            ? bookPersistido.contatos.filter((registro) => (registro?.origem || '') !== 'telefone')
            : [];
        if (Array.isArray(contatosSalvos) && contatosSalvos.length) {
            const lista = contatosSalvos.map((registro, index) => ({
                id: registro?.id ?? `contato-${index}-${gerarIdUnico()}`,
                origem: registro?.origem || 'dados_evento',
                responsavelId: '',
                nome: registro?.nome || '',
                email: registro?.email || '',
                telefone: registro?.telefone || '',
                agenda_id: registro?.agenda_id ?? registro?.agendaId ?? registro?.agenda ?? null,
                principal: Boolean(registro?.principal)
            }));
            setContatos(lista);
            setContatosInicializados(true);
            return;
        }

        setContatos([criarContatoItem()]);

        setContatosInicializados(true);
    }, [bookPersistido, contatosInicializados, criarContatoItem, gerarIdUnico, responsaveisEvento]);

    useEffect(() => {
        if (telefonesInicializados) {
            return;
        }

        const telefonesSalvos = Array.isArray(bookPersistido?.contatos)
            ? bookPersistido.contatos.filter((registro) => (registro?.origem || '') === 'telefone')
            : (Array.isArray(bookPersistido?.telefones) ? bookPersistido.telefones : []);
        if (Array.isArray(telefonesSalvos) && telefonesSalvos.length) {
            const lista = telefonesSalvos.map((registro, index) => ({
                id: registro?.id ?? `telefone-${index}-${gerarIdUnico()}`,
                origem: registro?.origem || 'telefone',
                responsavelId: '',
                nome: registro?.nome || '',
                email: registro?.email || '',
                telefone: registro?.telefone || '',
                agenda_id: registro?.agenda_id ?? registro?.agendaId ?? registro?.agenda ?? null,
                principal: Boolean(registro?.principal)
            }));
            setTelefones(lista);
            setTelefonesInicializados(true);
            return;
        }

        setTelefones([criarTelefoneItem()]);

        setTelefonesInicializados(true);
    }, [bookPersistido, criarTelefoneItem, gerarIdUnico, responsaveisEvento, telefonesInicializados]);

    const adicionarAgendaBloco = () => {
        setAgendaBlocos((prev) => [...prev, criarAgendaItem()]);
    };

    const removerAgendaBloco = (id) => {
        setAgendaBlocos((prev) => (prev.length > 1 ? prev.filter((item) => item.id !== id) : prev));
    };

    const atualizarAgendaBloco = (id, campo, valor) => {
        setAgendaBlocos((prev) => prev.map((item) => (item.id === id ? { ...item, [campo]: valor } : item)));
    };

    const adicionarContato = () => {
        const agendaPadrao = tabKey === 'agenda'
            ? (agendaBlocos.find((item) => item.agendaId) || null)
            : null;

        setContatos((prev) => [
            ...prev,
            {
                ...criarContatoItem(),
                agenda_id: agendaPadrao?.agendaId ?? null
            }
        ]);
    };

    const removerContato = (id) => {
        setContatos((prev) => (prev.length > 1 ? prev.filter((item) => item.id !== id) : prev));
    };

    const handleContatoSelecao = (contatoId, valorSelecionado) => {
        setContatos((prev) => prev.map((contato) => {
            if (contato.id !== contatoId) {
                return contato;
            }

            if (!valorSelecionado || valorSelecionado === NOVO_CONTATO_VALUE) {
                return {
                    ...contato,
                    origem: 'novo',
                    responsavelId: '',
                    nome: '',
                    email: '',
                    telefone: '',
                    agenda_id: contato.agenda_id || null
                };
            }

            const responsavel = responsaveisEvento.find((item) => item.id === valorSelecionado);
            if (responsavel) {
                return {
                    ...contato,
                    origem: 'existente',
                    responsavelId: responsavel.id,
                    nome: responsavel.nome,
                    email: responsavel.email,
                    telefone: responsavel.telefone,
                    agenda_id: contato.agenda_id || null
                };
            }

            return contato;
        }));
    };

    const atualizarContatoCampo = (contatoId, campo, valor) => {
        setContatos((prev) => prev.map((contato) => (contato.id === contatoId ? { ...contato, [campo]: valor } : contato)));
    };

    const adicionarTelefone = () => {
        const agendaPadrao = tabKey === 'agenda'
            ? (agendaBlocos.find((item) => item.agendaId) || null)
            : null;

        setTelefones((prev) => [
            ...prev,
            {
                ...criarTelefoneItem(),
                agenda_id: agendaPadrao?.agendaId ?? null
            }
        ]);
    };

    const removerTelefone = (id) => {
        setTelefones((prev) => (prev.length > 1 ? prev.filter((item) => item.id !== id) : prev));
    };

    const handleTelefoneSelecao = (telefoneId, valorSelecionado) => {
        setTelefones((prev) => prev.map((item) => {
            if (item.id !== telefoneId) {
                return item;
            }

            if (!valorSelecionado || valorSelecionado === NOVO_CONTATO_VALUE) {
                return {
                    ...item,
                    origem: 'novo',
                    responsavelId: '',
                    nome: '',
                    email: '',
                    telefone: '',
                    agenda_id: item.agenda_id || null
                };
            }

            const responsavel = responsaveisEvento.find((res) => res.id === valorSelecionado);
            if (responsavel) {
                return {
                    ...item,
                    origem: 'existente',
                    responsavelId: responsavel.id,
                    nome: responsavel.nome,
                    email: responsavel.email,
                    telefone: responsavel.telefone,
                    agenda_id: item.agenda_id || null
                };
            }

            return item;
        }));
    };

    const atualizarTelefoneCampo = (telefoneId, campo, valor) => {
        setTelefones((prev) => prev.map((item) => (item.id === telefoneId ? { ...item, [campo]: valor } : item)));
    };

    const adicionarAbBloco = () => {
        setAbBlocos((prev) => [...prev, criarAbItem()]);
    };

    const removerAbBloco = (id) => {
        setAbBlocos((prev) => (prev.length > 1 ? prev.filter((item) => item.id !== id) : prev));
    };

    const atualizarAbCampo = (id, campo, valor) => {
        setAbBlocos((prev) => prev.map((item) => (item.id === id ? { ...item, [campo]: valor } : item)));
    };

    const adicionarAbDescricao = (id) => {
        setAbBlocos((prev) => prev.map((item) => {
            if (item.id !== id) {
                return item;
            }
            const descricoes = Array.isArray(item.descricoes) ? item.descricoes : [];
            return { ...item, descricoes: [...descricoes, ''] };
        }));
    };

    const removerAbDescricao = (id, indice) => {
        setAbBlocos((prev) => prev.map((item) => {
            if (item.id !== id) {
                return item;
            }
            const descricoes = Array.isArray(item.descricoes) ? item.descricoes : [];
            if (descricoes.length <= 1) {
                return item;
            }
            return { ...item, descricoes: descricoes.filter((_, idx) => idx !== indice) };
        }));
    };

    const atualizarAbDescricao = (id, indice, valor) => {
        setAbBlocos((prev) => prev.map((item) => {
            if (item.id !== id) {
                return item;
            }
            const descricoes = Array.isArray(item.descricoes) ? item.descricoes : [];
            const atualizado = descricoes.map((texto, idx) => (idx === indice ? valor : texto));
            return { ...item, descricoes: atualizado };
        }));
    };

    const renderAb = () => {
        return (
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <span className="fin-pp__cphead-title">Blocos A&amp;B</span>
                    <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={adicionarAbBloco}>
                        <FaPlus size={13} style={{ marginRight: 6 }} /> Adicionar bloco
                    </button>
                </div>

                {abBlocos.map((bloco, index) => (
                    <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 12 }} key={bloco.id}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                            <span className="fin-pp__cell-strong">Bloco {index + 1}</span>
                            <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost" onClick={() => removerAbBloco(bloco.id)} disabled={abBlocos.length === 1}>
                                <FaTrash size={13} style={{ marginRight: 4 }} /> Remover
                            </button>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Data">
                                <input type="date" className="fin-pp__input" style={{ paddingLeft: 14 }} value={bloco.data || ''} onChange={(e) => atualizarAbCampo(bloco.id, 'data', e.target.value)} />
                            </FinField>
                            <FinField label="Título" full>
                                <FinInput placeholder="Título" value={bloco.titulo || ''} onChange={(e) => atualizarAbCampo(bloco.id, 'titulo', e.target.value)} />
                            </FinField>
                        </div>
                        <div style={{ marginTop: 12 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                <span className="fin-pp__label">Descrições</span>
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => adicionarAbDescricao(bloco.id)}>
                                    <FaPlus size={13} style={{ marginRight: 4 }} /> Adicionar descrição
                                </button>
                            </div>
                            {(Array.isArray(bloco.descricoes) ? bloco.descricoes : ['']).map((texto, idx) => (
                                <div key={`${bloco.id}-desc-${idx}`} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', marginBottom: 8 }}>
                                    <FinTextarea style={{ height: 'auto', padding: '10px 14px', flex: 1 }} rows={2} placeholder={`Descrição ${idx + 1}`} value={texto} onChange={(e) => atualizarAbDescricao(bloco.id, idx, e.target.value)} />
                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost" onClick={() => removerAbDescricao(bloco.id, idx)} disabled={(bloco.descricoes || []).length <= 1}>
                                        <FaTrash size={13} />
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
                {!abBlocos.length && <p className="fin-pp__empty" style={{ padding: 32 }}>Nenhum bloco A&amp;B cadastrado.</p>}
            </div>
        );
    };

    const renderAgenda = () => {
        const contatosAgenda = contatos.filter((c) => (c.origem === 'agenda') || c.agenda_id);

        return (
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <span className="fin-pp__cphead-title">Blocos da agenda</span>
                    <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={adicionarAgendaBloco}>
                        <FaPlus size={13} style={{ marginRight: 6 }} /> Adicionar bloco
                    </button>
                </div>

                {agendaBlocos.map((bloco, index) => (
                    <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 12 }} key={bloco.id}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                            <span className="fin-pp__cell-strong">Bloco {index + 1}</span>
                            <button
                                type="button"
                                className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost"
                                onClick={() => removerAgendaBloco(bloco.id)}
                                disabled={agendaBlocos.length === 1}
                            >
                                <FaTrash size={13} style={{ marginRight: 4 }} /> Remover
                            </button>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Data inicial">
                                <input type="date" className="fin-pp__input" style={{ paddingLeft: 14 }} value={bloco.dataInicio || ''} onChange={(e) => atualizarAgendaBloco(bloco.id, 'dataInicio', e.target.value)} />
                            </FinField>
                            <FinField label="Data final">
                                <input type="date" className="fin-pp__input" style={{ paddingLeft: 14 }} value={bloco.dataFim || ''} onChange={(e) => atualizarAgendaBloco(bloco.id, 'dataFim', e.target.value)} />
                            </FinField>
                            <FinField label="Título" full>
                                <FinInput placeholder="Título do bloco" value={bloco.titulo} onChange={(e) => atualizarAgendaBloco(bloco.id, 'titulo', e.target.value)} />
                            </FinField>
                        </div>
                        <div style={{ marginTop: 12 }}>
                            <FinField label="Descrição" full>
                                <FinTextarea placeholder="Descrição das atividades" rows={3} value={bloco.descricao} onChange={(e) => atualizarAgendaBloco(bloco.id, 'descricao', e.target.value)} />
                            </FinField>
                        </div>
                    </div>
                ))}
                {!agendaBlocos.length && <p className="fin-pp__empty" style={{ padding: 32 }}>Nenhum bloco de agenda cadastrado.</p>}

                {renderContatos(contatosAgenda)}
            </div>
        );
    };

    const renderContatos = (listaOverride) => {
        const lista = Array.isArray(listaOverride) ? listaOverride : contatos;

        return (
            <div style={{ marginTop: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <span className="fin-pp__cphead-title">Contatos</span>
                    <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={adicionarContato}>
                        <FaPlus size={13} style={{ marginRight: 6 }} /> Adicionar contato
                    </button>
                </div>

                {lista.length ? lista.map((contato, index) => {
                    const selectValue = contato.origem === 'novo' ? NOVO_CONTATO_VALUE : contato.responsavelId;
                    return (
                        <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 12 }} key={contato.id}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                <span className="fin-pp__cell-strong">Contato {index + 1}</span>
                                <button
                                    type="button"
                                    className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost"
                                    onClick={() => removerContato(contato.id)}
                                    disabled={contatos.length === 1}
                                >
                                    <FaTrash size={13} style={{ marginRight: 4 }} /> Remover
                                </button>
                            </div>
                            <div className="fin-pp__filters">
                                <FinField label="Responsável pelo evento (aba Detalhes)" full>
                                    <select className="fin-pp__select" style={{ height: 44 }} value={selectValue || ''} onChange={(e) => handleContatoSelecao(contato.id, e.target.value)}>
                                        <option value="">Selecione um responsável</option>
                                        {responsaveisEvento.map((r) => <option key={r.id} value={r.id}>{r.nome}</option>)}
                                        <option value={NOVO_CONTATO_VALUE}>Cadastrar novo coordenador</option>
                                    </select>
                                </FinField>
                                <FinField label="Nome">
                                    <FinInput placeholder="Nome" value={contato.nome} onChange={(e) => atualizarContatoCampo(contato.id, 'nome', e.target.value)} />
                                </FinField>
                                <FinField label="Email">
                                    <FinInput type="email" placeholder="Email" value={contato.email} onChange={(e) => atualizarContatoCampo(contato.id, 'email', e.target.value)} />
                                </FinField>
                                <FinField label="Telefone">
                                    <InputMask mask="(99) 99999-9999" className="fin-pp__input" style={{ paddingLeft: 14 }} placeholder="Telefone" value={contato.telefone} onChange={(e) => atualizarContatoCampo(contato.id, 'telefone', e.target.value)} />
                                </FinField>
                            </div>
                        </div>
                    );
                }) : (
                    <p className="fin-pp__empty" style={{ padding: 32 }}>Nenhum contato adicionado.</p>
                )}
            </div>
        );
    };

    const renderTelefones = () => {
        return (
            <div>
                <div style={{ marginTop: 16 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                        <span className="fin-pp__cphead-title">Contatos</span>
                        <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={adicionarTelefone}>
                            <FaPlus size={13} style={{ marginRight: 6 }} /> Adicionar contato
                        </button>
                    </div>

                    {telefones.length ? telefones.map((contato, index) => {
                        const selectValue = contato.origem === 'novo' ? NOVO_CONTATO_VALUE : contato.responsavelId;
                        return (
                            <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 12 }} key={contato.id}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                    <span className="fin-pp__cell-strong">Contato {index + 1}</span>
                                    <button
                                        type="button"
                                        className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost"
                                        onClick={() => removerTelefone(contato.id)}
                                        disabled={telefones.length === 1}
                                    >
                                        <FaTrash size={13} style={{ marginRight: 4 }} /> Remover
                                    </button>
                                </div>
                                <div className="fin-pp__filters">
                                    <FinField label="Responsável pelo evento (aba Detalhes)" full>
                                        <select className="fin-pp__select" style={{ height: 44 }} value={selectValue || ''} onChange={(e) => handleTelefoneSelecao(contato.id, e.target.value)}>
                                            <option value="">Selecione um responsável</option>
                                            {responsaveisEvento.map((r) => <option key={r.id} value={r.id}>{r.nome}</option>)}
                                            <option value={NOVO_CONTATO_VALUE}>Cadastrar novo coordenador</option>
                                        </select>
                                    </FinField>
                                    <FinField label="Nome">
                                        <FinInput placeholder="Nome" value={contato.nome} onChange={(e) => atualizarTelefoneCampo(contato.id, 'nome', e.target.value)} />
                                    </FinField>
                                    <FinField label="Email">
                                        <FinInput type="email" placeholder="Email" value={contato.email} onChange={(e) => atualizarTelefoneCampo(contato.id, 'email', e.target.value)} />
                                    </FinField>
                                    <FinField label="Telefone">
                                        <InputMask mask="(99) 99999-9999" className="fin-pp__input" style={{ paddingLeft: 14 }} placeholder="Telefone" value={contato.telefone} onChange={(e) => atualizarTelefoneCampo(contato.id, 'telefone', e.target.value)} />
                                    </FinField>
                                </div>
                            </div>
                        );
                    }) : (
                        <p className="fin-pp__empty" style={{ padding: 32 }}>Nenhum contato adicionado.</p>
                    )}
                </div>
            </div>
        );
    };

    const abrirImportacaoRlHcp = () => {
        rlHcpInputRef.current?.click();
    };

    const isCsvFile = useCallback((file) => {
        if (!file) {
            return false;
        }
        const nome = typeof file?.name === 'string' ? file.name.toLowerCase() : '';
        return nome.endsWith('.csv');
    }, []);

    const importarRlHcpCsv = useCallback(async (file) => {
        if (!file) {
            return;
        }

        if (!isCsvFile(file)) {
            toast.error('Envie um arquivo CSV (.csv).');
            return;
        }

        try {
            setRlHcpImportState({ loading: true, erro: '' });
            setRlHcpUploadProgresso({ ativo: true, nome: file.name, percent: 0 });

            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(
                `${apiBaseUrl}/evento/${eventoId}/book/rlhcp/import`,
                formData,
                {
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: (progressEvent) => {
                        const total = progressEvent?.total || 0;
                        const loaded = progressEvent?.loaded || 0;
                        const percent = total > 0 ? Math.round((loaded * 100) / total) : 0;
                        setRlHcpUploadProgresso({ ativo: true, nome: file.name, percent });
                    },
                }
            );

            const bookAtualizado = response?.data?.data;
            const linhasApi = bookAtualizado?.rlhcp;
            const linhas = mapearRlHcpLinhas(linhasApi);

            setBookPersistido(bookAtualizado || null);
            setRlHcpLinhas(linhas);
            setRlHcpInicializado(true);
            setRlHcpFiltroTexto('');
            setRlHcpImportState({ loading: false, erro: '' });
            setRlHcpUploadProgresso({ ativo: false, nome: file.name, percent: 100 });
            toast.success(`RL HCP importado: ${linhas.length} linha(s).`);
        } catch (error) {
            const mensagem = error?.response?.data?.error || error?.response?.data?.message || 'Erro ao importar RL HCP.';
            setRlHcpImportState({ loading: false, erro: mensagem });
            setRlHcpUploadProgresso({ ativo: false, nome: file?.name || '', percent: 0 });
            toast.error(mensagem);
        }
    }, [apiBaseUrl, eventoId, isCsvFile, mapearRlHcpLinhas, token]);

    const onRlHcpInputChange = useCallback(async (event) => {
        const file = event.target.files?.[0] || null;
        event.target.value = '';
        await importarRlHcpCsv(file);
    }, [importarRlHcpCsv]);

    const onRlHcpDrop = useCallback(async (event) => {
        event.preventDefault();
        setRlHcpDragAtivo(false);
        const file = event.dataTransfer?.files?.[0] || null;
        await importarRlHcpCsv(file);
    }, [importarRlHcpCsv]);

    const renderRlHcp = () => {
        const localEvento = montarEnderecoEvento(dados);

        const linhasFiltradas = (() => {
            const termo = normalizarTexto(rlHcpFiltroTexto).toLowerCase();
            if (!termo) {
                return rlHcpLinhas;
            }

            return rlHcpLinhas.filter((linha) => {
                const conteudo = [
                    linha?.tipo_quarto,
                    linha?.nome,
                    linha?.observacao,
                    linha?.check_in,
                    linha?.check_out,
                    linha?.cpf,
                    linha?.telefone,
                    linha?.nascimento,
                    linha?.cidade,
                    linha?.estado,
                ]
                    .map((item) => (item ?? ''))
                    .join(' ')
                    .toLowerCase();
                return conteudo.includes(termo);
            });
        })();

        return (
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <span className="fin-pp__cphead-title">RL HCP</span>
                </div>

                <input
                    type="file"
                    ref={rlHcpInputRef}
                    style={{ display: 'none' }}
                    accept=".csv,text/csv"
                    onChange={onRlHcpInputChange}
                />

                {rlHcpImportState.erro ? (
                    <div style={{ color: 'var(--fin-dg)', marginBottom: 12 }}>{rlHcpImportState.erro}</div>
                ) : null}

                <div
                    className="fin-pp__card"
                    style={{
                        padding: 24,
                        textAlign: 'center',
                        cursor: rlHcpImportState.loading ? 'not-allowed' : 'pointer',
                        border: rlHcpDragAtivo ? '2px dashed var(--fin-ac)' : '2px dashed #d1d5db',
                        borderRadius: 10,
                        marginBottom: 12
                    }}
                    onDragOver={(e) => { e.preventDefault(); if (!rlHcpImportState.loading) { setRlHcpDragAtivo(true); } }}
                    onDragLeave={() => { setRlHcpDragAtivo(false); }}
                    onDrop={onRlHcpDrop}
                    onClick={() => { if (!rlHcpImportState.loading) { abrirImportacaoRlHcp(); } }}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (rlHcpImportState.loading) {
                            return;
                        }
                        if (e.key === 'Enter' || e.key === ' ') {
                            abrirImportacaoRlHcp();
                        }
                    }}
                >
                    <FaUpload size={28} style={{ color: 'var(--fin-ac)', marginBottom: 8 }} />
                    <p style={{ marginBottom: 4, fontWeight: 600 }}>Arraste ou clique para importar o CSV</p>
                    <p style={{ color: 'var(--fin-mt)', fontSize: 12, marginBottom: 0 }}>Apenas arquivos .csv</p>

                    {rlHcpUploadProgresso?.ativo ? (
                        <div style={{ marginTop: 12 }} onClick={(e) => e.stopPropagation()}>
                            <div style={{ fontSize: 12, color: 'var(--fin-mt)', marginBottom: 4 }}>
                                Enviando{rlHcpUploadProgresso.nome ? `: ${rlHcpUploadProgresso.nome}` : ''}
                            </div>
                            <div className="progress" style={{ height: '10px' }}>
                                <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{ width: `${Math.min(100, Math.max(0, rlHcpUploadProgresso.percent || 0))}%` }}
                                    aria-valuenow={rlHcpUploadProgresso.percent || 0}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                />
                            </div>
                        </div>
                    ) : null}

                    {rlHcpImportState.loading ? (
                        <div style={{ marginTop: 12, display: 'flex', alignItems: 'center' }} onClick={(e) => e.stopPropagation()}>
                            <div style={{ display: 'inline-block', width: 18, height: 18, border: '2px solid var(--fin-acb)', borderTopColor: 'var(--fin-ac)', borderRadius: '50%', animation: 'spin 0.8s linear infinite', flexShrink: 0 }} role="status" aria-label="Carregando" />
                            <span style={{ marginLeft: 8 }}>Processando importação...</span>
                        </div>
                    ) : null}
                </div>

                {!rlHcpLinhas.length ? (
                    <p className="fin-pp__empty" style={{ padding: 32 }}>Importe um CSV para visualizar o RL HCP.</p>
                ) : (
                    <div>
                        <div className="fin-pp__card fin-pp__search" style={{ marginBottom: 12 }}>
                            <div className="fin-pp__search-field">
                                <input
                                    id="rlhcp-busca"
                                    type="text"
                                    className="fin-pp__input"
                                    style={{ paddingLeft: 14 }}
                                    placeholder="Buscar por nome, CPF, cidade, datas..."
                                    value={rlHcpFiltroTexto}
                                    onChange={(e) => setRlHcpFiltroTexto(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                            <div className="fin-pp__tblwrap">
                                <table className="fin-pp__tbl">
                                    <thead>
                                        <tr>
                                            <th>Tipo</th>
                                            <th>Local</th>
                                            <th>Nome</th>
                                            <th>Observação</th>
                                            <th>IN</th>
                                            <th>OUT</th>
                                            <th>CPF</th>
                                            <th>Telefone</th>
                                            <th>Nascimento</th>
                                            <th>Cidade</th>
                                            <th>Estado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {linhasFiltradas.map((linha) => (
                                            <tr key={linha.id}>
                                                <td>{valorOuHifen(linha.tipo_quarto)}</td>
                                                <td>{valorOuHifen(localEvento)}</td>
                                                <td>{valorOuHifen(linha.nome)}</td>
                                                <td>{valorOuHifen(linha.observacao)}</td>
                                                <td>{valorOuHifen(formatarDataCurta(linha.check_in))}</td>
                                                <td>{valorOuHifen(formatarDataCurta(linha.check_out))}</td>
                                                <td>{valorOuHifen(linha.cpf)}</td>
                                                <td>{valorOuHifen(linha.telefone)}</td>
                                                <td>{valorOuHifen(formatarDataCurta(linha.nascimento))}</td>
                                                <td>{valorOuHifen(linha.cidade)}</td>
                                                <td>{valorOuHifen(linha.estado)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const renderTabelaParticipantes = (state, mensagemVazio) => {
        if (state.loading) {
            return (
                <div style={{ textAlign: 'center', padding: 32 }}>
                    <div style={{ display: 'inline-block', width: 32, height: 32, border: '3px solid var(--fin-acb)', borderTopColor: 'var(--fin-ac)', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} role="status" aria-label="Carregando" />
                    <p style={{ marginTop: 8, color: 'var(--fin-mt)', fontSize: 13 }}>Carregando inscrições...</p>
                </div>
            );
        }

        if (state.erro) {
            return (
                <div className="fin-pp__card" style={{ padding: 16, color: 'var(--fin-dg)' }}>{state.erro}</div>
            );
        }

        if (!state.lista.length) {
            return (
                <div className="fin-pp__tblwrap"><p className="fin-pp__empty" style={{ padding: 32 }}>{mensagemVazio}</p></div>
            );
        }

        return (
            <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                <div className="fin-pp__tblwrap">
                    <table className="fin-pp__tbl">
                        <thead><tr>
                            <th>Nome</th>
                            <th>E-mail</th>
                            <th>Telefone</th>
                        </tr></thead>
                        <tbody>
                            {state.lista.map((participante) => (
                                <tr key={participante.id || participante.codigo}>
                                    <td className="fin-pp__cell-strong">{participante.nome || '-'}</td>
                                    <td>{obterEmailParticipante(participante) || '-'}</td>
                                    <td className="fin-pp__cell-muted">{obterTelefoneParticipante(participante) || '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    const filtrarListaParticipantes = useCallback((lista, filtroTexto) => {
        const termo = normalizarTexto(filtroTexto).toLowerCase();
        if (!termo) {
            return Array.isArray(lista) ? lista : [];
        }

        const origem = Array.isArray(lista) ? lista : [];
        return origem.filter((participante) => {
            const nome = normalizarTexto(participante?.nome).toLowerCase();
            const email = normalizarTexto(obterEmailParticipante(participante)).toLowerCase();
            const telefone = normalizarTexto(obterTelefoneParticipante(participante)).toLowerCase();
            return `${nome} ${email} ${telefone}`.includes(termo);
        });
    }, [normalizarTexto, obterEmailParticipante, obterTelefoneParticipante]);

    const renderTabelaParticipantesComFiltro = (state, mensagemVazio, filtroTexto, setFiltroTexto, inputId) => {
        if (state.loading || state.erro) {
            return renderTabelaParticipantes(state, mensagemVazio);
        }

        const listaOriginal = Array.isArray(state.lista) ? state.lista : [];
        const listaFiltrada = filtrarListaParticipantes(listaOriginal, filtroTexto);
        const mensagem = (normalizarTexto(filtroTexto) && listaOriginal.length && !listaFiltrada.length)
            ? 'Nenhum resultado para este filtro.'
            : mensagemVazio;

        return (
            <div>
                {listaOriginal.length ? (
                    <div className="fin-pp__card fin-pp__search" style={{ marginBottom: 12 }}>
                        <div className="fin-pp__search-field">
                            <input id={inputId} type="text" className="fin-pp__input" style={{ paddingLeft: 14 }} placeholder="Buscar por nome, e-mail ou telefone..." value={filtroTexto} onChange={(e) => setFiltroTexto(e.target.value)} />
                        </div>
                    </div>
                ) : null}

                {renderTabelaParticipantes({ ...state, lista: listaFiltrada }, mensagem)}
            </div>
        );
    };

    const renderInscricoes = () => renderTabelaParticipantesComFiltro(
        inscricoesState,
        'Nenhum participante encontrado para este evento.',
        inscricoesFiltroTexto,
        setInscricoesFiltroTexto,
        'inscricoes-busca'
    );

    const renderInscricaoExpositor = () => renderTabelaParticipantesComFiltro(
        inscricaoExpositorState,
        'Nenhum expositor encontrado para este evento.',
        inscricaoExpositorFiltroTexto,
        setInscricaoExpositorFiltroTexto,
        'inscricao-expositor-busca'
    );

    const renderAereoHcp = () => {
        if (inscricoesState.loading) {
            return (
                <div style={{ textAlign: 'center', padding: 32 }}>
                    <div style={{ display: 'inline-block', width: 32, height: 32, border: '3px solid var(--fin-acb)', borderTopColor: 'var(--fin-ac)', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} role="status" aria-label="Carregando" />
                    <p style={{ marginTop: 8, color: 'var(--fin-mt)', fontSize: 13 }}>Carregando inscrições...</p>
                </div>
            );
        }

        if (inscricoesState.erro) {
            return (
                <div className="fin-pp__card" style={{ padding: 16, color: 'var(--fin-dg)', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <FaExclamationTriangle size={16} /> {inscricoesState.erro}
                </div>
            );
        }

        if (!inscricoesState.lista.length) {
            return (
                <div className="fin-pp__tblwrap"><p className="fin-pp__empty" style={{ padding: 32 }}>Nenhum participante com dados de aéreo disponível.</p></div>
            );
        }

        return (
            <div className="fin-pp__card" style={{ overflow: 'hidden', marginBottom: 16 }}>
                <div className="fin-pp__tblwrap">
                    <table className="fin-pp__tbl" style={{ minWidth: 1400, tableLayout: 'auto' }}>
                        <thead>
                            <tr>
                                <th rowSpan="2" style={{ verticalAlign: 'middle' }}>Nome do convidado</th>
                                <th rowSpan="2" style={{ verticalAlign: 'middle' }}>Documentação CPF</th>
                                <th rowSpan="2" style={{ verticalAlign: 'middle' }}>Comunicação Access</th>
                                <th colSpan="9" style={{ textAlign: 'center' }}>Ida</th>
                                <th colSpan="9" style={{ textAlign: 'center' }}>Retorno</th>
                            </tr>
                            <tr>
                                <th>Data</th><th>CIA</th><th>Voo</th><th>Origem</th><th>Destino</th><th>Saída</th><th>Chegada</th><th>Localizador</th><th>Eticket</th>
                                <th>Data</th><th>CIA</th><th>Voo</th><th>Origem</th><th>Destino</th><th>Saída</th><th>Chegada</th><th>Localizador</th><th>Eticket</th>
                            </tr>
                        </thead>
                        <tbody>
                            {inscricoesState.lista.map((participante) => {
                                const idLinha = participante.id || participante.codigo;
                                const telefone = valorOuHifen(obterTelefoneParticipante(participante));
                                const cpf = valorOuHifen(formatarCpf(participante.cpf));

                                const ida = {
                                    data: formatarDataCurta(participante.aereoidadata),
                                    cia: valorOuHifen(participante.aereoidacompanhia),
                                    voo: valorOuHifen(participante.aereoidavoo),
                                    origem: valorOuHifen(participante.aereoidaorigem),
                                    destino: valorOuHifen(participante.aereoidadestino),
                                    saida: valorOuHifen(formatarHora(participante.aereoidahorasaida)),
                                    chegada: valorOuHifen(formatarHora(participante.aereoidahorachegada)),
                                    localizador: valorOuHifen(participante.aereoidalocalizador),
                                    eticket: valorOuHifen(participante.aereoidaeticket)
                                };

                                const retorno = {
                                    data: formatarDataCurta(participante.aereoretornodata),
                                    cia: valorOuHifen(participante.aereoretornocompanhia),
                                    voo: valorOuHifen(participante.aereoretornovoo),
                                    origem: valorOuHifen(participante.aereoretornoorigem),
                                    destino: valorOuHifen(participante.aereoretornodestino),
                                    saida: valorOuHifen(formatarHora(participante.aereoretornohorasaida)),
                                    chegada: valorOuHifen(formatarHora(participante.aereoretornohorachegada)),
                                    localizador: valorOuHifen(participante.aereoretornolocalizador),
                                    eticket: valorOuHifen(participante.aereoretornoeticket)
                                };

                                return (
                                    <tr key={idLinha}>
                                        <td>{valorOuHifen(participante.nome)}</td>
                                        <td>{cpf}</td>
                                        <td>{telefone}</td>
                                        <td>{ida.data}</td>
                                        <td>{ida.cia}</td>
                                        <td>{ida.voo}</td>
                                        <td>{ida.origem}</td>
                                        <td>{ida.destino}</td>
                                        <td>{ida.saida}</td>
                                        <td>{ida.chegada}</td>
                                        <td>{ida.localizador}</td>
                                        <td>{ida.eticket}</td>
                                        <td>{retorno.data}</td>
                                        <td>{retorno.cia}</td>
                                        <td>{retorno.voo}</td>
                                        <td>{retorno.origem}</td>
                                        <td>{retorno.destino}</td>
                                        <td>{retorno.saida}</td>
                                        <td>{retorno.chegada}</td>
                                        <td>{retorno.localizador}</td>
                                        <td>{retorno.eticket}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    const renderFotosModal = () => {
        if (!fotosModal.aberto || !fotosModal.abaId) {
            return null;
        }

        const aba = fotosAbas.find((item) => item.id === fotosModal.abaId);
        const itens = aba?.itens || [];
        const atual = itens[fotosModal.indice] || {};
        const nome = atual?.nome || 'Foto';
        const link = atual?.url;

        return (
            <div className="fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) fecharModalFotos(); }}>
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content fin-pp__modal">
                        <div className="fin-pp__modal-head">
                            <h3 className="fin-pp__modal-title">{nome}</h3>
                            <button type="button" className="fin-pp__modal-close" onClick={fecharModalFotos}><FaTimes size={16} /></button>
                        </div>
                        <div className="modal-body" style={{ textAlign: 'center', background: '#f9fbff', padding: 28 }}>
                            {link ? (
                                <img src={link} alt={nome} style={{ maxHeight: '70vh', maxWidth: '100%', objectFit: 'contain', borderRadius: 14 }} />
                            ) : (
                                <div style={{ color: 'var(--fin-mt)' }}>Imagem não disponível.</div>
                            )}
                        </div>
                        {itens.length > 1 ? (
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => navegarModalFotos(-1)}>Anterior</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary" onClick={() => navegarModalFotos(1)}>Próximo</button>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    };

    const renderFotos = () => {
        const chaveAtiva = fotosAbaAtiva || fotosAbas[0]?.id || '';

        return (
            <div className="fotos-area">
                <div className="fin-pp__filters" style={{ marginBottom: 16 }}>
                    <FinField label="Nome da nova aba de fotos" grow>
                        <FinInput placeholder="Ex: Stand" value={fotosNovoNome} onChange={(e) => setFotosNovoNome(e.target.value)} />
                    </FinField>
                    <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                        <button type="button" className="fin-pp__btn fin-pp__btn--primary" onClick={criarAbaFotos}>Salvar</button>
                    </div>
                </div>

                <input
                    type="file"
                    ref={fotosInputRef}
                    style={{ display: 'none' }}
                    multiple
                    accept="image/*"
                    onChange={onFotosInputChange}
                />

                {fotosAbas.length ? (
                    <div>
                        <div className="fin-pp__tabs" style={{ marginBottom: 12 }}>
                            {fotosAbas.map((aba) => {
                                const uploadAtivoNestaAba = fotosUploadProgresso?.ativo && fotosUploadProgresso?.abaId === aba.id;
                                return (
                                    <button
                                        type="button"
                                        key={aba.id}
                                        className={`fin-pp__tab${chaveAtiva === aba.id ? ' is-active' : ''}`}
                                        onClick={() => setFotosAbaAtiva(aba.id)}
                                    >
                                        {aba.nome}
                                        <span
                                            role="button"
                                            tabIndex={-1}
                                            style={{ background: 'none', border: 'none', marginLeft: 6, padding: 0, cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}
                                            title="Remover aba"
                                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); removerAbaFotos(aba.id); }}
                                            aria-disabled={uploadAtivoNestaAba}
                                        >
                                            <FaTimes size={11} style={{ color: 'var(--fin-dg)' }} />
                                        </span>
                                    </button>
                                );
                            })}
                        </div>

                        {fotosAbas.map((aba) => {
                            if (aba.id !== chaveAtiva) return null;
                            const itens = aba?.itens || [];
                            const dragAtivo = fotosDragAbaId === aba.id;
                            const uploadAtivoNestaAba = fotosUploadProgresso?.ativo && fotosUploadProgresso?.abaId === aba.id;

                            return (
                                <div key={aba.id}>
                                    <div
                                        className="fin-pp__card"
                                        style={{
                                            padding: 24,
                                            textAlign: 'center',
                                            cursor: 'pointer',
                                            border: dragAtivo ? '2px dashed var(--fin-ac)' : '2px dashed #d1d5db',
                                            borderRadius: 10
                                        }}
                                        onDragOver={(e) => { e.preventDefault(); setFotosDragAbaId(aba.id); }}
                                        onDragLeave={() => { if (fotosDragAbaId === aba.id) { setFotosDragAbaId(''); } }}
                                        onDrop={(e) => {
                                            e.preventDefault();
                                            setFotosDragAbaId('');
                                            adicionarFotosNaAba(aba.id, e.dataTransfer.files);
                                        }}
                                        onClick={() => abrirSeletorFotos(aba.id)}
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                abrirSeletorFotos(aba.id);
                                            }
                                        }}
                                    >
                                        <FaUpload size={28} style={{ color: 'var(--fin-ac)', marginBottom: 8 }} />
                                        <p style={{ marginBottom: 4, fontWeight: 600 }}>Arraste ou clique para enviar fotos</p>
                                        <p style={{ color: 'var(--fin-mt)', fontSize: 12, marginBottom: 0 }}>Apenas imagens. Redimensionamos para 1920x1080 e 2MB.</p>

                                        {uploadAtivoNestaAba ? (
                                            <div style={{ marginTop: 12 }} onClick={(e) => e.stopPropagation()}>
                                                <div style={{ fontSize: 12, color: 'var(--fin-mt)', marginBottom: 4 }}>
                                                    Enviando {fotosUploadProgresso.indice}/{fotosUploadProgresso.total}{fotosUploadProgresso.nome ? `: ${fotosUploadProgresso.nome}` : ''}
                                                </div>
                                                <div className="progress" style={{ height: '10px' }}>
                                                    <div
                                                        className="progress-bar"
                                                        role="progressbar"
                                                        style={{ width: `${Math.min(100, Math.max(0, fotosUploadProgresso.percent || 0))}%` }}
                                                        aria-valuenow={fotosUploadProgresso.percent || 0}
                                                        aria-valuemin={0}
                                                        aria-valuemax={100}
                                                    />
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>

                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 12, marginTop: 16 }}>
                                        {itens.map((foto, index) => (
                                            <div key={foto.id || index} className="fin-pp__card" style={{ overflow: 'hidden', padding: 0 }}>
                                                <div style={{ position: 'relative', minHeight: 120, background: '#f8f9fa' }}>
                                                    {foto?.url ? (
                                                        <img src={foto.url} alt={foto.nome || 'Foto'} style={{ width: '100%', height: 120, objectFit: 'cover', cursor: 'pointer', display: 'block' }} onClick={() => abrirModalFotos(aba.id, index)} />
                                                    ) : (
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 120, color: 'var(--fin-mt)' }}>
                                                            <FaFileAlt size={26} />
                                                        </div>
                                                    )}
                                                    <button type="button" style={{ position: 'absolute', top: 4, right: 4, background: 'rgba(255,255,255,0.9)', border: 'none', borderRadius: '50%', width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => removerFotoDaAba(aba.id, foto.id)}>
                                                        <FaTimes size={11} />
                                                    </button>
                                                </div>
                                                <div style={{ padding: '6px 8px', fontSize: 11, color: 'var(--fin-mt)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={foto.nome}>{foto.nome}</div>
                                            </div>
                                        ))}
                                    </div>
                                    {!itens.length && <p className="fin-pp__empty" style={{ padding: 32 }}>Nenhuma foto adicionada.</p>}
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <p className="fin-pp__empty" style={{ padding: 32 }}>Crie uma aba para adicionar fotos.</p>
                )}

                {renderFotosModal()}
            </div>
        );
    };

    const renderConteudo = () => {
        if (loading) {
            return (
                <div style={{ textAlign: 'center', padding: 32 }}>
                    <div style={{ display: 'inline-block', width: 32, height: 32, border: '3px solid var(--fin-acb)', borderTopColor: 'var(--fin-ac)', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} role="status" aria-label="Carregando" />
                    <p style={{ color: 'var(--fin-mt)', fontSize: 13, marginTop: 8, marginBottom: 0 }}>Carregando dados...</p>
                </div>
            );
        }

        if (erro) {
            return (
                <div className="fin-pp__card" style={{ padding: '16px', color: 'var(--fin-dg)', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <FaExclamationTriangle size={16} /> {erro}
                </div>
            );
        }

        if (!dados) {
            return (
                <div className="fin-pp__card" style={{ padding: '16px', color: 'var(--fin-wn)', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <FaInfoCircle size={16} /> Nenhum dado disponível para este evento.
                </div>
            );
        }

        return (
            <div>
                <div className="fin-pp__head" style={{ marginBottom: 16 }}>
                    <div style={{ flex: 1 }} />
                    <div className="fin-pp__actions">
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--sm"
                            onClick={exportarExcelBook}
                            disabled={exportarExcelState.loading}
                        >
                            {exportarExcelState.loading ? 'Exportando...' : 'Exportar Excel'}
                        </button>
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary"
                            onClick={salvarBook}
                            disabled={salvarBookState.loading}
                        >
                            {salvarBookState.loading ? 'Salvando...' : 'Salvar book'}
                        </button>
                    </div>
                </div>

                <div className="fin-pp__tabs" style={{ marginBottom: 12 }}>
                    <button type="button" className={`fin-pp__tab${tabKey === 'dados-evento' ? ' is-active' : ''}`} onClick={() => setTabKey('dados-evento')}>Dados do evento</button>
                    <button type="button" className={`fin-pp__tab${tabKey === 'inscricoes' ? ' is-active' : ''}`} onClick={() => setTabKey('inscricoes')}>Inscrições</button>
                    <button type="button" className={`fin-pp__tab${tabKey === 'aereo-hcp' ? ' is-active' : ''}`} onClick={() => setTabKey('aereo-hcp')}>Aéreo HCP</button>
                    <button type="button" className={`fin-pp__tab${tabKey === 'rl-hcp' ? ' is-active' : ''}`} onClick={() => setTabKey('rl-hcp')}>RL HCP</button>
                    <button type="button" className={`fin-pp__tab${tabKey === 'inscricao-expositor' ? ' is-active' : ''}`} onClick={() => setTabKey('inscricao-expositor')}>Inscrição expositor</button>
                    <button type="button" className={`fin-pp__tab${tabKey === 'agenda' ? ' is-active' : ''}`} onClick={() => setTabKey('agenda')}>Agenda</button>
                    <button type="button" className={`fin-pp__tab${tabKey === 'telefones' ? ' is-active' : ''}`} onClick={() => setTabKey('telefones')}>Telefones</button>
                    <button type="button" className={`fin-pp__tab${tabKey === 'ab' ? ' is-active' : ''}`} onClick={() => setTabKey('ab')}>A&amp;B</button>
                    <button type="button" className={`fin-pp__tab${tabKey === 'fotos' ? ' is-active' : ''}`} onClick={() => setTabKey('fotos')}>Fotos</button>
                </div>

                <div className="fin-pp__card" style={{ padding: '16px 20px' }}>
                    {tabKey === 'dados-evento' && (
                        <div>
                            <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                                <div className="fin-pp__cphead">
                                    <span className="fin-pp__cphead-ic"><FaInfoCircle size={15} /></span>
                                    <span className="fin-pp__cphead-title">Dados do evento</span>
                                    <span className="fin-pp__cphead-sub">Revise antes de gerar o book</span>
                                </div>
                            </div>
                            <div className="fin-pp__filters" style={{ marginBottom: 16 }}>
                                <FinField label="Nome do cliente">
                                    <FinInput value={bookDados.clienteNome} onChange={(e) => handleCampoChange('clienteNome', e.target.value)} placeholder="Nome do cliente" />
                                </FinField>
                                <FinField label="Nome do evento">
                                    <FinInput value={bookDados.eventoNome} onChange={(e) => handleCampoChange('eventoNome', e.target.value)} placeholder="Nome do evento" />
                                </FinField>
                                <FinField label="Endereço do evento" full>
                                    <FinInput value={bookDados.endereco} onChange={(e) => handleCampoChange('endereco', e.target.value)} placeholder="Endereço do evento" />
                                </FinField>
                            </div>
                            <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                                <div className="fin-pp__cphead">
                                    <span className="fin-pp__cphead-title">Responsável pelo evento</span>
                                </div>
                            </div>
                            <div className="fin-pp__filters">
                                <FinField label="Empresa contratante">
                                    <FinInput value={bookDados.empresaContratante} onChange={(e) => handleCampoChange('empresaContratante', e.target.value)} placeholder="Empresa contratante" />
                                </FinField>
                                <FinField label="Responsável pelo evento">
                                    <FinInput value={bookDados.responsavelNome} onChange={(e) => handleCampoChange('responsavelNome', e.target.value)} placeholder="Nome do responsável" />
                                </FinField>
                                <FinField label="Telefone do responsável">
                                    <InputMask mask="(99) 99999-9999" className="fin-pp__input" style={{ paddingLeft: 14 }} placeholder="Telefone" value={bookDados.responsavelTelefone} onChange={(e) => handleCampoChange('responsavelTelefone', e.target.value)} />
                                </FinField>
                                <FinField label="E-mail do responsável">
                                    <FinInput type="email" value={bookDados.responsavelEmail} onChange={(e) => handleEmailChange(e.target.value)} onBlur={(e) => handleEmailChange(e.target.value)} placeholder="E-mail" />
                                    {emailErro ? <span style={{ color: 'var(--fin-dg)', fontSize: 12, marginTop: 4 }}>{emailErro}</span> : null}
                                </FinField>
                            </div>
                        </div>
                    )}
                    {tabKey === 'inscricoes' && renderInscricoes()}
                    {tabKey === 'aereo-hcp' && renderAereoHcp()}
                    {tabKey === 'rl-hcp' && renderRlHcp()}
                    {tabKey === 'inscricao-expositor' && renderInscricaoExpositor()}
                    {tabKey === 'agenda' && renderAgenda()}
                    {tabKey === 'telefones' && renderTelefones()}
                    {tabKey === 'ab' && renderAb()}
                    {tabKey === 'fotos' && renderFotos()}
                </div>
            </div>
        );
    };

    const tituloEvento = bookDados.eventoNome || dados?.nome || '';

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h2 className="fin-pp__title">Book do Evento</h2>
                        <p className="fin-pp__subtitle">{tituloEvento}</p>
                    </div>
                    <div className="fin-pp__actions">
                        <a href="/evento" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--pill"><FaArrowLeft size={14} style={{ marginRight: 6 }} />Voltar</a>
                    </div>
                </div>
                {renderConteudo()}
            </div>
        </ErpTemplate>
    );
}
